import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'PUBLIC_'

export function appointmentCreate(data, filters){
  const url = `/anonymous/${API_VERSION_ONE}/appointments`;
  const method = 'POST'

  return {
    type: `${parent}APPOINTMENT_CREATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function appointmentSelectedSlot(slot){
  return {
    type: `${parent}APPOINTMENT_SELECTED_SLOT`,
    slot
  };
}